export default __webpack_public_path__ + "static/media/135-deg.e0e9535a.svg";